import React from "react";
import { formatCoin } from "../../../utils/utils";
import { useSelector } from "react-redux";

export default function ValueCoin() {
  const coinValue = useSelector((state: any) => state?.coinPrices?.BTC || 0);

  return <p className="value">${formatCoin(coinValue, 2)}</p>;
}
